/**
 * Ready2Book design system typography class names.
 * Pairs with `src/styles/_r2b-typography.scss` (display-* and text-* classes).
 *
 * Legacy Vuetify-oriented tokens remain in VuetifyTextClass.js.
 */
export default Object.freeze({
  display2xl: 'display-2xl',
  displayXl: 'display-xl',
  displayLg: 'display-lg',
  displayMd: 'display-md',
  displaySm: 'display-sm',
  displayXs: 'display-xs',
  display2xs: 'display-2xs',

  textLg: 'text-lg',
  textLgBold: 'text-lg-bold',
  textMd: 'text-md',
  textMdBold: 'text-md-bold',
  textSm: 'text-sm',
  textSmBold: 'text-sm-bold',
  textXs: 'text-xs',
  textXsBold: 'text-xs-bold',
})
